import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "rc-paginationWrap" };
const _hoisted_3 = { class: "pagination" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { key: 2 };
const _hoisted_8 = { key: 3 };
import { computed, defineAsyncComponent } from "vue";
// Async Components
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginationNav',
    props: {
        sr: {},
        limit: {},
        count: {},
        margin: { default: 4 }
    },
    emits: ["update:sr"],
    setup(__props, { emit: __emit }) {
        /******************************
         *  Component: Pagination
         *
         * 	Purpose: Reusable pagination component. Takes sr, limit, count and a callback function returns the new sr when
         * 			 a page is clicked.
         *
         * 	Input/Props:
         * 		- sr: Index of first item on current page
         * 		- limit: Number of items allowed on an individual page
         * 		- count: Number of total items. Used to calculate number of pages
         * 		- margin: Number of pages shown before showing [...]
         *
         * 	Output/Emit:
         * 		- @update:sr(new_sr): Function defined in parent element. Called upon page selection
         *
         ******************************/
        const SvgIcon = defineAsyncComponent(() => import("@/common/components/SvgIcon.vue"));
        // Setup
        const props = __props;
        const emit = __emit;
        const currentPage = computed(() => Math.floor(props.sr / props.limit) + 1);
        const lastPage = computed(() => Math.ceil(props.count / props.limit));
        const needEllipsis = computed(() => lastPage.value > props.margin + 2);
        const showPreEllipsis = computed(() => needEllipsis.value && currentPage.value > 4);
        const showPostEllipsis = computed(() => needEllipsis.value && lastPage.value - currentPage.value >= 4);
        /** n to n1 is the range of pages to be shown between [1] and [{last_page}] */
        const n = computed(() => showPreEllipsis.value ? Math.min(currentPage.value - 1, lastPage.value - (props.margin - 1)) : 2);
        const n1 = computed(() => showPostEllipsis.value ? Math.max(currentPage.value + 1, props.margin) : lastPage.value - 1);
        const goToPage = (page) => {
            emit("update:sr", (page - 1) * props.limit);
        };
        return (_ctx, _cache) => {
            return (_ctx.count > _ctx.limit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("nav", _hoisted_2, [
                        _createElementVNode("ul", _hoisted_3, [
                            (lastPage.value > -1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (currentPage.value > 1)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                                            _createElementVNode("a", {
                                                href: "#",
                                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (goToPage(currentPage.value - 1)), ["prevent"]))
                                            }, [
                                                _createVNode(_unref(SvgIcon), {
                                                    icon: "icon-arrow-left",
                                                    class: "rc-icon-arrow-left rc-f-p-100"
                                                })
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ active: currentPage.value < 2 })
                                    }, [
                                        _createElementVNode("a", {
                                            href: "#",
                                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (goToPage(1)), ["prevent"]))
                                        }, "1")
                                    ], 2),
                                    (showPreEllipsis.value)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                                            _createElementVNode("a", {
                                                href: "#",
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (goToPage(currentPage.value - 2)), ["prevent"]))
                                            }, "...")
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(n1.value - n.value + 1, (i, idx) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: idx,
                                            class: _normalizeClass({ active: currentPage.value == n.value + idx })
                                        }, [
                                            _createElementVNode("a", {
                                                href: "#",
                                                onClick: _withModifiers(($event) => (goToPage(n.value + idx)), ["prevent"])
                                            }, _toDisplayString(n.value + idx), 9, _hoisted_6)
                                        ], 2));
                                    }), 128)),
                                    (showPostEllipsis.value)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                                            _createElementVNode("a", {
                                                href: "#",
                                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (goToPage(currentPage.value + 2)), ["prevent"]))
                                            }, "...")
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ active: currentPage.value >= lastPage.value })
                                    }, [
                                        _createElementVNode("a", {
                                            href: "#",
                                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (goToPage(lastPage.value)), ["prevent"]))
                                        }, _toDisplayString(lastPage.value), 1)
                                    ], 2),
                                    (currentPage.value < lastPage.value)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                                            _createElementVNode("a", {
                                                href: "#",
                                                onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (goToPage(currentPage.value + 1)), ["prevent"]))
                                            }, [
                                                _createVNode(_unref(SvgIcon), {
                                                    icon: "icon-arrow-right",
                                                    class: "rc-icon-arrow-right rc-f-p-100"
                                                })
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 64))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
